module.exports = ":host {\n  display: block; }\n\n.button-list {\n  width: 100%;\n  height: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/button-list/button-list.component.scss
// module id = ./src/app/ui/button-list/button-list.component.scss
// module chunks = main